import '../styles/pages/PolitiqueConfidentialite.scss';
import { useTranslation } from 'react-i18next';

const PolitiqueConfidentialite = () => {
    const { t } = useTranslation();
    return (
        <div className="main-container">
            <div className='politique-header'>
                <h1>{t('privacy.header.title')} <span className='colored'>{t('privacy.header.colored')}</span></h1>
            </div>
            <div className='politique-content'>
                <div className='politique-section'>
                    <h2>{t('privacy.section1.title')}</h2>
                    <div className='politique-text'>
                        <p>{t('privacy.section1.text')}</p>
                    </div>
                </div>

                <div className='politique-section'>
                    <h2>{t('privacy.section2.title')}</h2>
                    <div className='politique-text'>
                        <p>{t('privacy.section2.intro')}</p>
                        <ul>
                            <li>{t('privacy.section2.l1')}</li>
                            <li>{t('privacy.section2.l2')}</li>
                            <li>{t('privacy.section2.l3')}</li>
                            <li>{t('privacy.section2.l4')}</li>
                        </ul>
                    </div>
                </div>

                <div className='politique-section'>
                    <h2>{t('privacy.section3.title')}</h2>
                    <div className='politique-text'>
                        <p>{t('privacy.section3.p1')}</p>
                        <p>{t('privacy.section3.p2')}</p>
                        <ul>
                            <li>{t('privacy.section3.l1')}</li>
                            <li>{t('privacy.section3.l2')}</li>
                        </ul>
                    </div>
                </div>

                <div className='politique-section'>
                    <h2>{t('privacy.section4.title')}</h2>
                    <div className='politique-text'>
                        <p>{t('privacy.section4.p1')}</p>
                        <ul>
                            <li>{t('privacy.section4.l1')}</li>
                            <li>{t('privacy.section4.l2')}</li>
                        </ul>
                        <p>{t('privacy.section4.p2')}</p>
                    </div>
                </div>

                <div className='politique-section'>
                    <h2>{t('privacy.section5.title')}</h2>
                    <div className='politique-text'>
                        <p>{t('privacy.section5.p1')}</p>
                        <ul>
                            <li>{t('privacy.section5.l1')}</li>
                            <li>{t('privacy.section5.l2')}</li>
                        </ul>
                    </div>
                </div>

                <div className='politique-section'>
                    <h2>{t('privacy.section6.title')}</h2>
                    <div className='politique-text'>
                        <p>{t('privacy.section6.text')}</p>
                    </div>
                </div>

                <div className='politique-section'>
                    <h2>{t('privacy.section7.title')}</h2>
                    <div className='politique-text'>
                        <p>{t('privacy.section7.text')}</p>
                    </div>
                </div>

                <div className='politique-section'>
                    <h2>{t('privacy.section8.title')}</h2>
                    <div className='politique-text'>
                        <p>{t('privacy.section8.text')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PolitiqueConfidentialite;
